import PropTypes from "prop-types";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

import Presenter from "utils/PropTypesPresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    animatedThumb: PropTypes.string,
    thumbnail: PropTypes.string,
  },
  {
    thumb(tg) {
      return this.thumbnail(tg);
    },

    previewPoster(tg) {
      return TemplateGroupPresenter.previewPoster(tg);
    },

    castNumOptions(tg) {
      return TemplateGroupPresenter.castNumOptions(tg);
    },

    castsCount(tg) {
      const { castNumOptions } = tg;
      return castNumOptions[0];
    },

    allCardsCount(items) {
      return items && items.length;
    },

    duration(tg) {
      dayjs.extend(duration);
      return dayjs.duration(tg.duration, "seconds").format("m:ss");
    },
  },
);
